/*
 * @Descripttion:
 * @version:
 * @Author: wangchengxian
 * @Date: 2021-04-07 10:37:38
 * @LastEditors: wangchengxian
 * @LastEditTime: 2021-06-18 14:49:52
 */
import Vue from "vue";

export default {
  namespaced: true,
  state() {
    return {
      // 个人信息
      selectedSex: "",
      selectedLanguage: "",
      quest: "",
      realName: "",
      imgUrl: "",
      idcard: ""
    };
  },
  mutations: {
    setSelectedSex(state: any, item: string) {
      state.selectedSex = item;
    },
    setselectedLanguage(state: any, item: string) {
      state.selectedLanguage = item;
    },
    setQuest(state: any, val: string) {
      state.quest = val;
    },
    setName(state: any, val: string) {
      state.realName = val;
    },
    setUrl(state: any, val: string) {
      state.imgUrl = val;
    },
    setidcard(state: any, val: string) {
      state.idcard = val;
    }
  }
};
